import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue';
import { useMediaQuery } from '@vueuse/core';
import AnimatedBackground from './components/AnimatedBackground.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isLoaded = ref(false);
const isDesktop = useMediaQuery('(min-width: 1024px)');
onMounted(() => {
isLoaded.value = true;
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isDesktop))
      ? (_openBlock(), _createBlock(AnimatedBackground, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component, route }) => [
        _createVNode(_Transition, {
          appear: "",
          name: route.meta.transition as string || 'fade' ,
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { if: isLoaded.value }, null, 8, ["if"]))
          ]),
          _: 2
        }, 1032, ["name"])
      ]),
      _: 1
    })
  ], 64))
}
}

})